import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Modal, Button, Icon, Segment, Loader, Message, List } from "semantic-ui-react";

import Api from "@Api";

import styles from "./styles.module.css";

// SELECT MODAL
const FlowSelectModal = ({ open, onClose, onSend, onConfigure, allowSendFlow, allowConfigFlow }) => {
	const [flows, setFlows] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		if (open) {
			loadFlows();
		}
	}, [open]);

	const loadFlows = async () => {
		setLoading(true);
		setError(null);
		try {
			const res = await Api.get("/flows/table", { params: { rows: 100, page: 1 } });
			const resData = res?.data?.data || res?.data || {};
			const items = resData?.items || (Array.isArray(resData) ? resData : []);
			setFlows(
				items.filter((f) => {
					return f.isActive;
				})
			);
		} catch (e) {
			setError(e?.response?.data?.message || "Error al cargar flows");
			setFlows([]);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal open={open} onClose={onClose} size="small" closeIcon centered>
			<Modal.Header style={{ backgroundColor: "var(--header)", color: "#fff", borderBottom: "none" }}>
				<Icon name="send" /> Seleccionar Flow
			</Modal.Header>
			<Modal.Content>
				{error && <Message error content={error} style={{ borderRadius: 10 }} />}
				{loading ? (
					<Loader active inline="centered" />
				) : flows.length === 0 ? (
					<Message info content="No hay flows activos disponibles" style={{ borderRadius: 10 }} />
				) : (
					<Segment style={{ borderRadius: 10 }}>
						<List divided relaxed>
							{flows.map((f) => {
								return (
									<List.Item key={f.id} className={styles.flowItem}>
										<Icon name="paper plane" color="blue" />
										<List.Content style={{ flex: 1 }}>
											<List.Header>{f.name || "Sin nombre"}</List.Header>
											<List.Description>{f.channel?.label && <span>Canal: {f.channel.label}</span>}</List.Description>
										</List.Content>
										{allowSendFlow && (
											<Button
												size="mini"
												onClick={(e) => {
													e.stopPropagation();
													onSend(f);
												}}
												className={`${styles.modalBtn} ${styles.modalBtnBlue}`}>
												<Icon name="send" /> Enviar
											</Button>
										)}
										{allowConfigFlow && (
											<Button
												size="mini"
												onClick={(e) => {
													e.stopPropagation();
													onConfigure(f);
												}}
												className={`${styles.modalBtn} ${styles.modalBtnGray}`}>
												<Icon name="cog" /> Personalizar
											</Button>
										)}
									</List.Item>
								);
							})}
						</List>
					</Segment>
				)}
			</Modal.Content>
			<Modal.Actions style={{ background: "#fff", borderTop: "1px solid #e8e8e8" }}>
				<Button onClick={onClose} className={`${styles.modalBtn} ${styles.modalBtnRed}`}>
					Cancelar
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

FlowSelectModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSend: PropTypes.func.isRequired,
	onConfigure: PropTypes.func.isRequired,
	allowSendFlow: PropTypes.bool,
	allowConfigFlow: PropTypes.bool,
};

export default FlowSelectModal;
